/**
 * Página de error del checkout AR
 * 
 * Cuando el pago falla o es rechazado en MercadoPago.
 */

import { BRAND_SUPPORT_EMAIL } from "@/lib/brandConfig";
import { useNavigate } from "react-router-dom";
import { AlertCircle, RefreshCw } from "lucide-react";

/** Font iOS (San Francisco) */
const FONT_FAMILY =
  '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif';

export default function InvitacionArError() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen bg-black text-white flex items-center justify-center px-4"
      style={{ fontFamily: FONT_FAMILY }}
    >
      {/* Fondo con gradiente */}
      <div className="fixed inset-0 -z-10 bg-black">
        <div className="absolute inset-0 bg-gradient-to-br from-red-500 via-pink-500 to-rose-500 opacity-20" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-transparent via-black/50 to-black" />
      </div>

      <div className="max-w-md w-full text-center space-y-6">
        {/* Icono de error */}
        <div className="relative inline-flex justify-center w-full">
          <div className="absolute inset-0 blur-2xl bg-red-500/40 animate-pulse" />
          <div className="relative w-24 h-24 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center shadow-2xl">
            <AlertCircle className="w-12 h-12 text-white" />
          </div>
        </div>

        {/* Título */}
        <h1 className="text-3xl font-bold bg-gradient-to-r from-red-400 to-pink-400 bg-clip-text text-transparent">
          Error en el pago
        </h1>

        {/* Mensaje */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
          <p className="text-gray-300 text-base leading-relaxed">
            No se pudo procesar tu pago. Esto puede deberse a fondos insuficientes, 
            tarjeta rechazada, o un problema temporal con el servicio de pago.
          </p>
        </div>

        {/* Botones */}
        <div className="space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="w-full py-4 px-6 bg-gradient-to-r from-red-500 to-pink-500 rounded-xl font-bold text-white shadow-lg hover:shadow-2xl transform hover:scale-105 active:scale-95 ui-transition duration-200 flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-5 h-5" />
            <span>Intentar de nuevo</span>
          </button>

          <button
            onClick={() => navigate("/")}
            className="w-full py-3 px-6 bg-white/10 hover:bg-white/20 rounded-xl font-semibold text-white transition-colors"
          >
            Volver al inicio
          </button>
        </div>

        {/* Footer */}
        <p className="text-gray-600 text-xs">
          Si el problema persiste,{" "}
          {BRAND_SUPPORT_EMAIL ? (
            <a href={`mailto:${BRAND_SUPPORT_EMAIL}`} className="underline hover:text-gray-400">
              {BRAND_SUPPORT_EMAIL}
            </a>
          ) : (
            "contactá a soporte"
          )}
          .
        </p>
      </div>
    </div>
  );
}
